import { QueryParams } from '../hooks/global/_types';

export const defaultReactQueryParams: Partial<QueryParams> = {
  retry: false,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};
